import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Header from '../../common/Header/Header';
import { headerImg } from '../../config';
import { GenericDiv, FlexDiv } from 'commonStyles';
import MyBizDocsBanner from './MyBizDocsBanner/MyBizDocsBanner';
import CardSection from './CardSection/CardSection';
import MetaTags from 'common/metaTags';
import { PATHS, INTEGRATION_AWARNESS_CONSTANTS } from 'AppConstants';
import { fetchIntegrationData } from 'reduxStore/actions/integrationActionDispatcher';
import { logOmniture } from 'UtilityComponents/intergarationUtils';
import ApiError from 'common/ApiError/ApiError';

const IntegrationLanding = () => {
	const dispatch = useDispatch();
	const scollToRef = useRef();
	const integrationData = useSelector((state) => state.integrationAwarness.integrationLandingData || {});
	const error = useSelector((state) => state.integrationAwarness.integrationLandingData.error || false);
	const { bannerData, cardSection, meta = {} } = integrationData;
	const { pageLoadEvent = {} } = meta;
	const { trackEvent, pageName } = pageLoadEvent;
	useEffect(() => {
		if (error || !integrationData.meta) {
			dispatch(fetchIntegrationData(INTEGRATION_AWARNESS_CONSTANTS.LANDING_CONFIG_KEY, INTEGRATION_AWARNESS_CONSTANTS.LANDING_REDUX_KEY));
		}
	}, []);

	useEffect(() => {
		logOmniture(trackEvent, PATHS.TRAVEL_INTEGRATION_LANDING, pageName);
	}, [trackEvent, pageName]);

	const btnHandler = () => {
		if (scollToRef && scollToRef.current) {
			scollToRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	if (error) {
		return (
			<FlexDiv height='100vh'>
				<ApiError
					$bg='#fbfbfb'
					textSize='14'
					imgMargin='25px'
					headSize='20px'
					bottom_P='63'
					top_P='40'
					imgWidth='100px'
					imgHeight='100px'
					$direction='column'
					justify='center'
					align='center'
					txtAlign='center'
				/>
			</FlexDiv>
		);
	}

	return (
		<GenericDiv>
			<MetaTags titleTxt={meta.title} description={meta.description} />
			<Header headerImg={headerImg.landing} isLanding headerBg='transparent' />
			<MyBizDocsBanner bannerData={bannerData} btnHandler={btnHandler} />
			<CardSection cardData={cardSection} scollToRef={scollToRef} />
		</GenericDiv>
	);
};

export default IntegrationLanding;
